import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "course-publish"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
var url = 'https://report.zhixuehuijiao.cn/webroot/decision/view/report?viewlet=teacher_contribution%252Fteacher_cont_pub.cpt&ref_t=design';
export default {
  __name: 'CoursePublish',
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url
      })]);
    };
  }
};